module.exports = __webpack_public_path__ + "img/R-3.0319ea68.png";